module.exports = __webpack_public_path__ + "static/media/elaine-alves.d0feccf8.jpeg";